import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import SelectComponent from './ui/SelectComponent'

const validate = {
	availability: value => value && value.length ? undefined : 'This field is required',
	dropdown: value => value === undefined && "*required"
}

const renderField = ({ input, className, label, type, avail, meta: { asyncValidating, touched, error, warning } }) => {
  if (touched && error) {
    return (
      <div className={className}>
      <div className="input-field">
        <label className="is-invalid-label">{avail.question}
          <input 
            {...input} 
            type={type}
            className="is-invalid-input" 
            placeholder={label} />
          <span className="form-error is-visible" id="uuid">{error}</span>
          { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
        </label>
      </div>
      </div>
    )
  }
  return (
    <div className={className}>
    <div className="input-field">
      <label>{avail.question}
        <input {...input} placeholder={label} type={type} />
        { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
      </label>
    </div>
    </div>
  )
}

const SelectBox = ({ question, options, className, id }) => (
	<div className={className}>
	<label>{question}
		<Field name={`availability[${'_'+id}]`} component="select" validate={[validate.availability]} >
				<option>Please Select</option>
	    	{options.map( (item, index) => 
    			<option key={index} value={item}>{item}</option> 
    		)}
	    </Field>
	</label>
	</div>
)

const InputBox = ({ question, classNames, id, placeholder }) => (
	<div className={classNames}>
    <label>{question}
      	<Field
            name={`availability[${'_'+id}]`}
            component="input"
            type="text"
            placeholder={placeholder}
            validate={[validate.availability]}
          />
    </label>
  </div>
)

const renderAvailability = (item) => {
	if (item.question_type === 'checkbox' || item.question_type === 'radio') {
		const options = JSON.parse(item.options);
		return <SelectBox 
				key={item.id}
				question={item.question} 
				options={options} 
				classNames="small-12 cell"
				id={item.id}/>
	} else {
		return <InputBox
				key={item.id}
				question={item.question} 
				classNames="small-12 cell"
				id={item.id}/>
	}
}

class Availability extends Component {

	async submit (values, dispatch, props) {
    if (typeof props.handleSave === "function") {
      props.handleSave(values)
    }
	  return props.onSubmit(props.handleSubmit)
	}

	optionValue(array) {
    return array.map((item, i) => ({value: item, label: item}))
  }

	render(){
    	const { handleSubmit, previousPage, nextPage, pristine, submitting, availability } = this.props
    	console.log('availa',availability)
    	return (
		<form onSubmit={handleSubmit(this.submit)} className="checking-availability-form" id="availability-form">

			<section className="section gray-bg">
				<div className="grid-x align-center">
				<div className="small-12 medium-10 large-8 cell">


					<div className="text-center">
						<p>This client would like to confirm the following 
						information in relation to this job. Please answer honestly and accurately
						</p>
					</div>

					{
			            availability.map((avail, i) => 
			              {
			                if (avail.question_type === 'checkbox' || avail.question_type === 'radio') {
			                	const options = JSON.parse(avail.options)
			                	return <div key={i} className="small-12 cell">
			                		<div className="input-field">
			                			<label className="is-invalid-label">{avail.question}</label>
			                			<Field key={i}
				                          name={`availability[${'_'+avail.id}]`}
				                          placeholder="Select an answer"
				                          component={SelectComponent}
				                          validate={[validate.dropdown]}
				                          options={this.optionValue(options)} />
				                    </div>
				                    </div>
			                } else {
			                  return <Field
			                    key={i}
			                    className="small-12 cell"
			                    name={`availability[${'_'+avail.id}]`}
			                    type="text"
			                    component={renderField}
			                    validate={[validate.availability]}
			                    label="Type your answer"
			                    avail={avail}
			                  />
			                }
			              })
			          }

				</div>
				</div>
			</section>

			<section className="section">
				<div className="grid-x align-center">
					<div className="small-12 cell text-center">
						{
	            previousPage &&
	            <button 
	              className="button primary previous" 
	              type="button" 
	              onClick={previousPage} >Previous</button>
	          }

	          {
	            nextPage 
	            ? <button className="button primary next" type="submit">Next</button>
	            : <button className="button primary" 
									type="submit" 
									disabled={pristine || submitting}>
										{submitting ? 'Submitting you checking...' : 'Submit' }
								</button>
	          }
					</div>
				</div>
			</section>
		</form>
	)
    }
}


export default reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(Availability)



// WEBPACK FOOTER //
// ./src/components/Availability.js